"use strict";import{css as s}from"@spectrum-web-components/base";const e=s`
:host{display:inline-flex}:host(:not([selected])){display:none}
`;export default e;
//# sourceMappingURL=tab-panel.css.js.map
